import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import CrudForm from '../../crud/CrudForm'
import {
    disabledaysService as service,
    companyService,
    usercompaniesService,
} from '../../../services'
import { useTranslation } from 'react-i18next'
import { idCompany } from '../../../utils/session'

const initElement = {
    day: null,
    name: null,
    user: { id: null, name: '' },
    company: { id: null, name: '' },
}

export default function FormCompanyUserDisabledays(props) {
    const [objectform, setObjectform] = React.useState({ ...initElement })
    type FormParms = {
        id: string
        company: string
        user: string
        userc: string
    }
    let { id, user, userc } = useParams<FormParms>()
    const [idRow, setIdrow] = useState(id ? Number(id) : 0)
    const { t, i18n } = useTranslation()
    var aux = {
        company: { id: idCompany(), name: '' },
        user: { id: user, name: '' },
    }
    const [object, setObject] = useState({
        ...initElement,
        ...aux,
    })

    const estructureform = [
        {
            type: 'autocomplete',
            name: 'user.id',
            service: usercompaniesService.combouser,
            col: 4,
            readonly: true,
        },
        {
            type: 'input',
            name: 'day',
            inputtype: 'date',
            col: 4,
        },
        {
            type: 'input',
            name: 'name',
            col: 4,
        },
    ]

    const recoveryElement = function (objectedit, element) {
        objectedit = element
        return objectedit
    }

    const isValid = function (object) {
        return null
    }

    return (
        <>
            <CrudForm
                objectform={{
                    ...object,
                }}
                estructureform={estructureform}
                i18n={'disableday'}
                urledit={
                    '/user/edit/' +
                    userc +
                    '/disableday/user/' +
                    user +
                    '/edit/'
                }
                urlCancel={'/users/edit/' + userc}
                service={service}
                recoveryElement={recoveryElement}
                valid={isValid}
            />
        </>
    )
}
